// Validation
function validateEmailAddresses () {
  const errors = []

  $("#inputs-container input[type!='hidden']").each(function () {
    const value = $(this).val()
    const validEmail = /^.+@.+\..+$/
    if (value !== '') {
      if (!validEmail.test(value)) {
        errors.push(i18next.t('emailer_invalid_email', { invalidEmail: value }))
      }
    }
  })

  return errors
}

function addAddressInput (event) {
  event.preventDefault()
  const $inputs = $('#inputs-container input.email-address')
  const $newInput = $inputs.first().clone()

  let currentID = $inputs.last().attr('id')
  currentID = currentID.split('-').pop()
  const newID = 'email-addy-' + String(parseInt(currentID, 10) + 1)

  $newInput.val('')
  $newInput.attr('id', newID)
  $newInput.attr('name', newID)
  $('#email-addresses #inputs-container').append($newInput)
}

function emailerAjax () {
  $('#email-addresses').ajaxForm({
    beforeSerialize: function () {
      const $submitBtn = $('#email-addresses button[type="submit"]')
      $submitBtn.prop('disabled', true)
      $submitBtn.addClass('loading')
      const errors = validateEmailAddresses()
      const $errorBox = $('#error-messages')
      if (errors.length === 0) {
        $errorBox.hide()
        return true
      }

      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      $errorBox.text(errors.join('\n'))
      $errorBox.slideDown()

      return false
    },
    cache: false,
    dataType: 'text',
    success: function (data) {
      const $submitBtn = $('#email-addresses button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      const $errorBox = $('#error-messages')
      let errorText = ''
      try {
        const response = JSON.parse(data)
        if (response.success) {
          window.location.href = '/thankyou/' + response.emailId
          return
        }

        if (response.error) {
          errorText = response.error
        }
      } catch (e) {
        errorText = i18next.t('catch_all_error')
      }
      $errorBox.text(errorText).slideDown()
    },
    error: function (jqXHR) {
      const $submitBtn = $('#email-addresses button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      const $errorBox = $('#error-messages')
      let errorText = jqXHR.responseText
      try {
        const json = JSON.parse(errorText)
        if (json.error) {
          errorText = json.error.replace(/,/g, '\n')
        }
      } catch (e) {
        errorText = i18next.t('catch_all_error')
      }
      $errorBox.text(errorText).slideDown()
    }
  })
}

// eslint-disable-next-line no-unused-vars
function emailerInit () {
  emailerAjax()
  $('#add-address').click(addAddressInput)
}
